import React, { useState, useEffect } from "react";
import Select from "react-select";
import { fetchImageAsFile } from "../../../helpers/helpers";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
  CustomInput,
  Alert,
} from "reactstrap";
import MDEditor from "@uiw/react-md-editor";
import Breadcrumb from "../../common/breadcrumb";
import axios from "axios";
import { useParams } from "react-router-dom";
import { productStatus } from "../../../assets/data/constants";
import toast from 'react-hot-toast';


const UpdateProduct = () => {
  const { id } = useParams(); // Récupère l'ID du produit à partir de l'URL
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [brands, setBrands] = useState([]);
  const brandOptions = brands.map((brand) => ({
    value: brand.id,
    label: brand.title,
  }));
  const [colors, setColors] = useState([]);
  const colorOptions = colors.map((color) => ({
    value: color.id,
    label: color.title,
  }));
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [errorMessages, setErrorMessages] = useState();
  const [successMessage, setSuccessMessage] = useState("");
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  // State for product data
  const [title, setTitle] = useState("");
  const [detail, setDetail] = useState("");
  const [price, setPrice] = useState("");
  const [stock, setStock] = useState(1);
  const [status, setStatus] = useState("");
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState([]);
  const [seller, setSeller] = useState("");
  const [color, setColor] = useState("");
  const [sizeLetter, setSizeLetter] = useState("");
  const [sizeNumber, setSizeNumber] = useState("");
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [brand, setBrand] = useState("");
  const [norefBrand, setNorefBrand] = useState("");
  const [images, setImages] = useState([]);
  const [existingImages, setExistingImages] = useState([]);

  const handleImageChange = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const updatedImages = [...images];
        updatedImages[index] = { img: reader.result, file: file };
        setImages(updatedImages);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleBrandChange = (selectedOption) => {
    setSelectedBrand(selectedOption);
    setBrand(selectedOption.value);
  };

  const handleColorChange = (selectedOption) => {
    setSelectedColor(selectedOption);
    setColor(selectedOption.value);
  };

  const handleCategoryChange = (e) => {
    const selectedCategoryId = e.target.value;
    setCategory(selectedCategoryId);

    const selectedCategory = categories.find(
      (category) => category.id.toString() === selectedCategoryId
    );

    if (selectedCategory && selectedCategory.subcategories) {
      setSubCategories(selectedCategory.subcategories);
    } else {
      setSubCategories([]);
    }
  };

  const handleSubCategoryChange = (subCatId) => {
    setSubCategory((prevSubCategory) => {
      if (prevSubCategory.includes(subCatId)) {
        return prevSubCategory.filter((id) => id !== subCatId);
      } else {
        return [...prevSubCategory, subCatId];
      }
    });
  };
  // Fetch categories from the API
  // useEffect(() => {
  //   fetch(`${baseUrl}/categories/`)
  //     .then((response) => response.json())
  //     .then((data) => setCategories(data.data));
  // }, []);

  // useEffect(() => {
  //   fetch(`${baseUrl}/brands/?no_pagination=true`)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (Array.isArray(data)) {
  //         setBrands(data);
  //       }
  //     })
  //     .catch((error) => {
  //       setBrands([]);
  //       console.error("Error fetching brands:", error);
  //     });
  // }, []);

  // useEffect(() => {
  //   axios
  //     .get(`${baseUrl}/product/${id}/`)
  //     .then(async (response) => {
  //       const productData = response.data;
  //       console.log("PRODUCTDATA:", productData);
  //       setTitle(productData.title);
  //       setDetail(productData.detail);
  //       setPrice(productData.price);
  //       setSelectedBrand({
  //         value: productData.brand.id,
  //         label: productData.brand.title,
  //       });
  //       setSelectedColor({
  //         value: productData.color.id,
  //         label: productData.color.title,
  //       });
  //       setSizeLetter(productData.size_letter);
  //       setSizeNumber(productData.size_number);
  //       setWidth(productData.width);
  //       setHeight(productData.height);
  //       setStock(productData.stock);
  //       setStatus(productData.status);
  //       setCategory(productData.category.id);
  //       const currentCategory = categories.find(
  //         (c) => c.id === productData.category.id
  //       );
  //       if (currentCategory) {
  //         setSubCategories(currentCategory.subcategories);
  //       }

  //       setExistingImages(productData.product_images);

  //       // Set selected subcategories
  //       const selectedSubCatIds = productData.subcategories.map(
  //         (subCat) => subCat.id
  //       );
  //       setSubCategory(selectedSubCatIds);

  //       const imageFiles = await Promise.all(
  //         productData.product_images.map((imgObj) =>
  //           fetchImageAsFile(imgObj.image, `image_${imgObj.id}.jpg`)
  //         )
  //       );

  //       setImages(
  //         imageFiles.map((file) => ({
  //           img: URL.createObjectURL(file),
  //           file: file,
  //         }))
  //       );
  //     })
  //     .catch((error) => console.log(error));
  // }, [id]);

  function base64ToFile(dataURI, filename) {
    let byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0) {
      byteString = atob(dataURI.split(",")[1]);
    } else {
      byteString = unescape(dataURI.split(",")[1]);
    }
    const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new File([ia], filename, { type: mimeString });
  }

  // useEffect(() => {
  //   fetch(`${baseUrl}/colors/?no_pagination=true`)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (Array.isArray(data)) {
  //         setColors(data);
  //       }
  //     })
  //     .catch((error) => {
  //       setColors([]);
  //       console.error("Error fetching colors:", error);
  //     });
  // }, []);

  const handleAddImage = () => {
    setImages([...images, { img: null }]);
  };

  const handleRemoveImage = (index) => {
    const updatedImages = images.filter((_, i) => i !== index);
    setImages(updatedImages);
  };

  // const submitHandler = (e) => {
  //   e.preventDefault();

  //   if (!title || title.trim() === "") {
  //     toast.error("Veuillez ajouter un titre pour ce produit");
  //     return;
  //   }

  //   if (!detail || detail.trim() === "") {
  //     toast.error("Veuillez ajouter une description du produit");
  //     return;
  //   }

  //   if (!price || isNaN(price)) {
  //     toast.error("Veuillez saisir un prix valide");
  //     return;
  //   }

  //   if (!stock || isNaN(stock)) {
  //     toast.error("Veuillez saisir le stock disponible");
  //     return;
  //   }

  //   if (!category) {
  //     toast.error("Veuillez sélectionner une catégorie");
  //     return;
  //   }

  //   if (!subCategory.length) {
  //     toast.error("Veuillez sélectionner au moins une sous-catégorie");
  //     return;
  //   }

  //   if (!color) {
  //     toast.error("Veuillez sélectionner une couleur");
  //     return;
  //   }

  //   if (!sizeLetter) {
  //     toast.error("Veuillez sélectionner une taille (lettre)");
  //     return;
  //   }

  //   if (!brand) {
  //     toast.error("Veuillez sélectionner une marque");
  //     return;
  //   }

  //   if (selectedBrand?.label === "Autre" && (!norefBrand || norefBrand.trim() === "")) {
  //     toast.error("Veuillez spécifier le nom de la marque");
  //     return;
  //   }

  //   if (images.length < 3 || images.some((img) => !img.img)) {
  //     toast.error("Veuillez ajouter au minimum 3 images : face, latéral et dos");
  //     return;
  //   }
  //   const formData = new FormData();
  //   formData.append("title", title);
  //   formData.append("detail", detail);
  //   formData.append("price", price);
  //   formData.append("stock", stock);
  //   formData.append("status", status);
  //   formData.append("category", category);
  //   formData.append("brand_id", brand);
  //   formData.append("noref_brand", norefBrand);
  //   formData.append("color_id", color);
  //   formData.append("size_letter", sizeLetter);
  //   formData.append("size_number", sizeNumber);
  //   formData.append("width", width);
  //   formData.append("height", height);
  //   subCategory.forEach((sc) => formData.append("subcategories", sc));

  //   images.forEach((image, index) => {
  //     if (image.img) {
  //       const file = base64ToFile(image.img, `product_image_${index}.png`);
  //       formData.append("images", image.file);
  //     }
  //   });

  //   axios
  //     .patch(`${baseUrl}/products/update/${id}/`, formData, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     })
  //     .then((response) => {
  //       setSuccessMessage("Produit mis à jour avec succès !");
  //     })
  //     .catch((error) => {
  //       setErrorMessages([
  //         error.response.data.message ||
  //         "Erreur lors de la mise à jour du produit.",
  //       ]);
  //     });
  // };


  useEffect(() => {
    fetchData(`${baseUrl}/categories/`, setCategories);
    fetchData(`${baseUrl}/brands/?no_pagination=true`, setBrands);
    fetchData(`${baseUrl}/colors/?no_pagination=true`, setColors);
  }, []);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(`${baseUrl}/product/${id}/`);
        const product = response.data;

        setTitle(product.title);
        setDetail(product.detail);
        setPrice(product.price);
        setSelectedBrand({ value: product.brand.id, label: product.brand.title });
        setBrand(product.brand.id);
        setNorefBrand(product.noref_brand)
        setColor(product.color.id);
        setSelectedColor({ value: product.color.id, label: product.color.title });
        setSizeLetter(product.size_letter);
        setSizeNumber(product.size_number);
        setWidth(product.width);
        setHeight(product.height);
        setStock(product.stock);
        setStatus(product.status);
        setCategory(product.category.id);
        setExistingImages(product.product_images);

        const currentCategory = categories.find(c => c.id === product.category.id);
        if (currentCategory) setSubCategories(currentCategory.subcategories);

        const subCatIds = product.subcategories.map(sub => sub.id);
        setSubCategory(subCatIds);

        const imageFiles = await Promise.all(
          product.product_images.map(img =>
            fetchImageAsFile(img.image, `image_${img.id}.jpg`)
          )
        );

        setImages(
          imageFiles.map(file => ({
            img: URL.createObjectURL(file),
            file: file,
          }))
        );
      } catch (err) {
        console.error("Error fetching product:", err);
      }
    };

    if (id) fetchProduct();
  }, [id, categories]);



  const fetchData = async (url, setter, fallback = []) => {
    try {
      const response = await fetch(url);
      const data = await response.json();
      if (Array.isArray(data.data || data)) {
        setter(data.data || data);
      } else {
        setter(fallback);
      }
    } catch (error) {
      console.error(`Error fetching from ${url}:`, error);
      setter(fallback);
    }
  };


  const submitHandler = (e) => {
    e.preventDefault();

    if (!title?.trim()) return toast.error("Veuillez ajouter un titre pour ce produit");
    if (!detail?.trim()) return toast.error("Veuillez ajouter une description du produit");
    if (!price || isNaN(price)) return toast.error("Veuillez saisir un prix valide");
    if (!stock || isNaN(stock)) return toast.error("Veuillez saisir le stock disponible");
    if (!category) return toast.error("Veuillez sélectionner une catégorie");
    if (!subCategory.length) return toast.error("Veuillez sélectionner au moins une sous-catégorie");
    if (!color) return toast.error("Veuillez sélectionner une couleur");
    if (!sizeLetter) return toast.error("Veuillez sélectionner une taille (lettre)");
    if (!brand) return toast.error("Veuillez sélectionner une marque");
    if (selectedBrand?.label === "Autre" && !norefBrand?.trim())
      return toast.error("Veuillez spécifier le nom de la marque");
    if (images.length < 3 || images.some((img) => !img.img))
      return toast.error("Veuillez ajouter au minimum 3 images : face, latéral et dos");

    const formData = new FormData();
    formData.append("title", title);
    formData.append("detail", detail);
    formData.append("price", price);
    formData.append("stock", stock);
    formData.append("status", status);
    formData.append("category", category);
    formData.append("brand_id", brand);
    if (brand == 4) {
      formData.append("noref_brand", norefBrand);
    }
    formData.append("color_id", color);
    formData.append("size_letter", sizeLetter);
    formData.append("size_number", sizeNumber);
    formData.append("width", width);
    formData.append("height", height);

    subCategory.forEach((sc) => formData.append("subcategories", sc));
    images.forEach((image, index) => {
      if (image.file) {
        formData.append("images", image.file);
      }
    });

    axios
      .patch(`${baseUrl}/products/update/${id}/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(() => setSuccessMessage("Produit mis à jour avec succès !"))
      .catch((error) =>
        setErrorMessages([
          error.response?.data?.message || "Erreur lors de la mise à jour du produit.",
        ])
      );
  };


  return (
    <Container fluid={true}>
      <Breadcrumb title="Ajouter produit" parent="Physical" />
      <Row>
        <Col sm="12">
          <Card>
            <CardHeader>
              <h5>Mettre a jour le produit</h5>
            </CardHeader>
            <CardBody>
              <Form>
                <FormGroup row>
                  <Label for="title" sm={3}>
                    Titre:
                  </Label>
                  <Col sm={9}>
                    <Input
                      id="title"
                      name="title"
                      placeholder="Nom du produit"
                      type="text"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      required
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="status" sm={3}>
                    Statut:
                  </Label>
                  <Col sm={9}>
                    <Input
                      type="select"
                      id="status"
                      name="status"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                      disabled={status === "Verification"} // Désactiver si le statut est 'En vérification'
                      required
                    >
                      <option value="">Sélectionner un statut</option>
                      {status == "Verification" && (
                        <option value="Verification">En vérification</option>
                      )}
                      {Object.entries(productStatus).map(([key, value]) => (
                        <option key={key} value={key}>
                          {value}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Label for="category" sm={3}>
                    Catégorie:
                  </Label>
                  <Col sm={9}>
                    <Input
                      type="select"
                      id="category"
                      name="category"
                      value={category}
                      onChange={handleCategoryChange}
                      required
                    >
                      <option value="">Sélectionner une catégorie</option>
                      {categories.map((category) => (
                        <option key={category.id} value={category.id}>
                          {category.title}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="subCategory" sm={3}>
                    Sous-catégorie(s) :
                  </Label>
                  <Col sm={9}>
                    {/* Générer des cases à cocher pour les sous-catégories */}
                    {subCategories.map((subCat) => (
                      <CustomInput
                        style={{ margin: "5px" }}
                        type="checkbox"
                        id={`subCategory-${subCat.id}`}
                        label={subCat.title}
                        checked={subCategory.includes(subCat.id)}
                        onChange={() => handleSubCategoryChange(subCat.id)}
                        key={subCat.id}
                      />
                    ))}
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Label for="detail" sm={3}>
                    Detail:
                  </Label>
                  <Col sm={9}>
                    <MDEditor value={detail} onChange={setDetail} />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="price" sm={3}>
                    Price:
                  </Label>
                  <Col sm={9}>
                    <Input
                      id="price"
                      name="price"
                      placeholder="Price"
                      type="number"
                      onWheel={(e) => e.target.blur()} // Ajout de cette ligne
                      value={price}
                      onChange={(e) => setPrice(e.target.value)}
                      required
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="stock" sm={3}>
                    Stock:
                  </Label>
                  <Col sm={9}>
                    <Input
                      id="stock"
                      name="stock"
                      placeholder="Stock"
                      type="number"
                      onWheel={(e) => e.target.blur()} // Ajout de cette ligne
                      value={stock}
                      onChange={(e) => setStock(e.target.value)}
                      required
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="size_letter" sm={3}>
                    Taille (Lettre) :
                  </Label>
                  <Col sm={9}>
                    <Input
                      type="select"
                      id="size_letter"
                      name="size_letter"
                      value={sizeLetter}
                      onChange={(e) => setSizeLetter(e.target.value)}
                      required
                    >
                      <option value="XS">Double Extra Small (XS) </option>
                      <option value="XS">Extra Small (XS) </option>
                      <option value="S">Small (S)</option>
                      <option value="M">Medium (M)</option>
                      <option value="L">Large(L)</option>
                      <option value="XL">Extra Large(XL)</option>
                      <option value="XXL">Double Extra Large(XXL)</option>
                    </Input>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="size_number" sm={3}>
                    Taille (Nombre):
                  </Label>
                  <Col sm={9}>
                    <Input
                      id="size_number"
                      name="size_number"
                      placeholder="Ecrire la taille si c'est un nombre"
                      type="number"
                      onWheel={(e) => e.target.blur()} // Ajout de cette ligne
                      value={sizeNumber}
                      onChange={(e) => setSizeNumber(e.target.value)}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="width" sm={3}>
                    Width:
                  </Label>
                  <Col sm={9}>
                    <Input
                      id="width"
                      name="width"
                      placeholder="Width"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      value={width}
                      onChange={(e) => setWidth(e.target.value)}
                    />
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Label for="height" sm={3}>
                    Height:
                  </Label>
                  <Col sm={9}>
                    <Input
                      id="height"
                      name="height"
                      placeholder="Height"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      value={height}
                      onChange={(e) => setHeight(e.target.value)}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="brand" sm={3}>
                    Brand:
                  </Label>
                  <Col sm={9}>
                    <Select
                      id="brand"
                      name="brand"
                      value={selectedBrand}
                      onChange={handleBrandChange}
                      options={brandOptions}
                      placeholder="Select or search a brand..."
                    />
                  </Col>
                </FormGroup>

                {selectedBrand && selectedBrand.label == "Autre" && (
                  <FormGroup row>
                    <Label for="noref_brand" sm={3}>
                      Spécifier la marque :
                    </Label>
                    <Col sm={9}>
                      <Input
                        id="noref_brand"
                        name="noref_brand"
                        placeholder="Nom de la marque non répertoriée"
                        value={norefBrand}
                        onChange={(e) => setNorefBrand(e.target.value)}
                      />
                    </Col>
                  </FormGroup>
                )}
                <FormGroup row>
                  <Label for="color" sm={3}>
                    Color:
                  </Label>
                  <Col sm={9}>
                    <Select
                      id="color"
                      name="color"
                      value={selectedColor}
                      onChange={handleColorChange}
                      options={colorOptions}
                      placeholder="Select or search a color..."
                    />
                  </Col>
                </FormGroup>

                {images.length > 0 && (
                  <Alert color="warning">
                    <p>
                      Attention : En ajoutant une nouvelle image, les images
                      existantes seront supprimées.
                    </p>
                  </Alert>
                )}
                {/* <Row>
                  {existingImages.map((image, index) => (
                    <Col key={index} md={4} sm={6} xs={12}>
                      <img
                        src={image.image}
                        alt={`existing_image_${index}`}
                        style={{
                          width: "50%",
                          height: "auto",
                          marginBottom: "10px",
                        }}
                      />
                    </Col>
                  ))}
                </Row> */}
                <FormGroup row>
                  <Label for="images" sm={3}>
                    Ajouter minimum 3 images : Dos, Face; Latérale
                  </Label>
                  <Col sm={9}>
                    {images.map((image, index) => (
                      <div key={index} style={{ marginTop: "10px" }}>
                        {image.img && (
                          <img
                            src={image.img}
                            alt={`product_image_${index}`}
                            style={{
                              width: 100,
                              height: 100,
                              display: "block",
                              marginBottom: "10px",
                            }}
                          />
                        )}
                        <Label
                          for={`image${index}`}
                          style={{ display: "block" }}
                        >
                          Image {index + 1}:
                        </Label>
                        <Input
                          type="file"
                          accept="image/*"
                          name={`image${index}`}
                          id={`image${index}`}
                          onChange={(e) => handleImageChange(e, index)}
                        />
                        <Button
                          color="danger"
                          onClick={() => handleRemoveImage(index)}
                          style={{ marginTop: "10px" }}
                        >
                          Supprimer
                        </Button>
                      </div>
                    ))}
                    <Button
                      color="light"
                      onClick={handleAddImage}
                      style={{ marginTop: "20px" }}
                    >
                      Ajouter une image
                    </Button>
                  </Col>
                </FormGroup>

                <Button onClick={submitHandler} type="submit" color="primary">
                  Modifier
                </Button>
              </Form>
              {errorMessages && (
                <div>
                  <Alert color="danger">
                    {errorMessages.map((error, index) => (
                      <p key={index}>{error}</p>
                    ))}
                  </Alert>
                </div>
              )}
              {successMessage && (
                <div>
                  <Alert color="success">{successMessage}</Alert>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default UpdateProduct;
